import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { configureAmplify } from './amplify'
import { GoogleTagManager } from './components/GoogleTagManager'
import './index.css'
import './i18n'

configureAmplify()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleTagManager />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
